$shm_ba_dashboard $mol_book2
	file? null
	files? /File
	file_uri? \
	local_file_key? \
	dashboard_model null $shm_ba_dashboard_model
	agent_enabled false
	pb_files_collection \user_files
	pb_files_field \file
	has_source false
	period? *
		from \0001-01-01
		to \2999-12-31
	period_all *
		from \0001-01-01
		to \2999-12-31
	data null $shm_ba_data
	query_posts null
	tags_filter? *
	message_types_filter? *
	source_types_filter? *
	authors_filter? *
	sources_filter? *
	search_query? \
	search_query_draft? \
	search_mode? \fts
	search_case_sensitive? true
	chart_metric? \Сообщений
	chart_group? \day
	posts_sort? \Дата
	posts_sort_order? \desc
	posts_page? 0
	screen? \summary
	report_id? \default
	report_current_title \
	dashboard_self null $shm_ba_dashboard
	app_id \
	filter_state_store null $shm_ba_filter_state_store
	placeholders /
	plugins /
		<= Theme $mol_theme_auto
	auto /
		^
		<= ba_mcp_client_auto null
	pages <= dashboard_pages /
		<= Report_page $mol_page
			title_content /
				<= Logo $mol_view
					sub /
						<= dashboard_title \BA
				<= Indicators_menu $shm_ba_dashboard_indicators
					dashboard_id <= app_id
					selected? => summary_indicators?
				<= Report_tabs $mol_view
					sub <= report_tab_rows /$mol_view
						<= Report_tab*0 $mol_view
							sub /
								<= Report_link* $mol_link
									arg <= report_arg* *
									current <= report_current* false
									title <= report_title* \
								<= Report_actions* $mol_view
									attr *
										^
										settings_opened <= report_settings_showed* false
									sub <= report_actions* /$mol_view
										<= Report_settings*0 $mol_pick
											align \bottom
											showed? <=> report_settings_showed*? false
											auto /
												^
												<= report_settings_outside_listener* null
											hint \Настройки отчета
											trigger_content /
												<= Report_settings_icon* $mol_icon_dots_vertical
											bubble_content /
												<= Report_settings_content* $mol_view
													sub <= report_settings_content* /$mol_view
														<= Report_title_input* $mol_string
															value? <=> report_title_draft*? \
															submit? <=> report_title_commit*? null
															event *
																^
																blur? <=> report_title_commit*? null
																keydown? <=> report_title_keydown*? null
														<= Report_delete* $mol_button_minor
															click? <=> report_delete_ask*? null
															sub /
																<= Report_delete_icon* $mol_icon_trash_can
																\Удалить
														<= Report_delete_text* $mol_text
															text \Удалить?
														<= Report_delete_yes* $mol_button_minor
															title \Да
															click? <=> report_delete_confirm*? null
														<= Report_delete_no* $mol_button_minor
															title \Нет
															click? <=> report_delete_cancel*? null
			tools /
				<= Csv_download $mol_button_download
					title \Скачать csv
					enabled <= has_source
					click? <=> csv_download? null
				<= File_label $mol_view
					sub /
						\Файлы:
				<= File_picker $shm_ba_file_picker
					app_id <= app_id
					file_uri? <=> file_uri? \
					local_file_key? <=> local_file_key? \
					pb_files_collection <= pb_files_collection
					pb_files_field <= pb_files_field
					remote_files <= dashboard_model_files /
					remote_files_forced true
			body <= report_rows /
		<= Filters_page $shm_ba_filter_panel
			has_source <= has_source
			state <= filter_state_store
			data <= data
			process_monitor_opened? <=> process_monitor_opened? false
	Process_monitor $shm_hitalama_process_monitor
	Ba_mcp_client $shm_ba_mcp_client
	Empty $mol_view
		sub /
			\Выберите CSV-файл Brand Analytics
	Summary_screen $mol_list
		rows /
			<= Summary_data $mol_view
				sub <= summary_data_rows /
			<= Posts $shm_ba_posts
				table <= query_posts_page null
				table_count <= query_posts_count 0
				highlight <= search_query? \
				sort? <=> posts_sort? \Дата
				sort_order? <=> posts_sort_order? \desc
				page? <=> posts_page? 0
	Summary_loading $mol_view
		sub /
			<= Summary_loading_content $mol_view
				sub /
					<= Summary_loading_title $mol_view
						sub / <= summary_loading_title \
					<= Summary_loading_dots $shm_dotsloader
	Summary $shm_ba_summary
		table <= query_summary null
		selected? <=> chart_metric? \Сообщений
		sort? <=> posts_sort? \Дата
		sort_order? <=> posts_sort_order? \desc
		page? <=> posts_page? 0
	Timeseries_chart $shm_ba_chart_timeseries
		rows <= chart_timeseries /
		title <= chart_metric? \Сообщений
		group? <=> chart_group? \day
		group_options <= chart_group_options *
		period_pick? <=> chart_period_pick? null
		period_range_pick? <=> chart_period_range_pick? null
		overlay_series /
		tools_left /
	Charts_screen $mol_list
		rows /
			<= Tag_messages_pie_chart $shm_ba_chart_tags
				rows <= tag_messages_pie /
	Converter_screen $mol_list
		rows /
			<= Converter $shm_ba_converter
				data <= data
	Custom_report_screen $mol_list
		rows /
			<= Custom_report_renderer $shm_ba_report_renderer
				report <= report_current_model null
				dashboard <= dashboard_self
